import { useAttendanceTrackingAccess } from 'contexts/AttendanceTrackingAccessContext';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import FingerprintOutlinedIcon from '@mui/icons-material/FingerprintOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import React from 'react';
import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';

interface Props {
  collapsed: boolean;
}

export const AttendanceTrackingSidebar = ({ collapsed }: Props) => {
  const location = useLocation();
  const { isAdmin, canUpload } = useAttendanceTrackingAccess();

  return (
    <aside
      className={`attendance-tracking-sidebar${
        collapsed ? ' attendance-tracking-sidebar--collapsed' : ''
      }`}
      aria-label="Attendance navigation"
    >
      <Sidebar
        collapsed={collapsed}
        backgroundColor="#ffffff"
        width="220px"
        collapsedWidth="72px"
        style={{ border: 'none', height: '100%' }}
      >
        <div className="attendance-tracking-sidebar__main">
          <div className="attendance-tracking-sidebar__menus">
            <div className="attendance-tracking-sidebar__heading">
              <span className="attendance-tracking-sidebar__heading-icon" aria-hidden>
                <FingerprintOutlinedIcon fontSize="small" />
              </span>
              <span className="attendance-tracking-sidebar__heading-label">
                Attendance Tracking
              </span>
            </div>

            <Menu>
              {isAdmin && (
                <MenuItem
                  icon={<DashboardOutlinedIcon fontSize="small" />}
                  component={<Link to="/attendance-tracking" />}
                  active={
                    location.pathname === '/attendance-tracking' ||
                    location.pathname === '/attendance-tracking/'
                  }
                >
                  Dashboard
                </MenuItem>
              )}
              {isAdmin && (
                <MenuItem
                  icon={<GroupsOutlinedIcon fontSize="small" />}
                  component={<Link to="/attendance-tracking/employees" />}
                  active={
                    location.pathname === '/attendance-tracking/employees' ||
                    location.pathname.startsWith(
                      '/attendance-tracking/employees/'
                    )
                  }
                >
                  Attendance
                </MenuItem>
              )}
              {isAdmin && (
                <MenuItem
                  icon={<DirectionsCarOutlinedIcon fontSize="small" />}
                  component={<Link to="/attendance-tracking/vehicles" />}
                  active={location.pathname === '/attendance-tracking/vehicles'}
                >
                  Vehicles
                </MenuItem>
              )}
              {canUpload && (
                <MenuItem
                  icon={<UploadFileOutlinedIcon fontSize="small" />}
                  component={<Link to="/attendance-tracking/upload" />}
                  active={location.pathname === '/attendance-tracking/upload'}
                >
                  Upload
                </MenuItem>
              )}
              {isAdmin && (
                <MenuItem
                  icon={<SettingsOutlinedIcon fontSize="small" />}
                  component={<Link to="/attendance-tracking/settings" />}
                  active={location.pathname === '/attendance-tracking/settings'}
                >
                  Settings
                </MenuItem>
              )}
            </Menu>
          </div>
        </div>
      </Sidebar>
    </aside>
  );
};
